var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.271,
    height: 14.266,
    viewBox: "0 0 14.271 14.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "watch",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M19549,5056.63a6.636,6.636,0,1,1,6.633,6.634A6.626,6.626,0,0,1,19549,5056.63Zm1.205-.038a5.43,5.43,0,1,0,5.475-5.39h-.031A5.43,5.43,0,0,0,19550.207,5056.592Zm6.734,2.195c-.557-.551-1.121-1.092-1.652-1.664a1.031,1.031,0,0,1-.25-.595c-.031-.575-.01-1.15-.01-1.725s0-1.13,0-1.694a.622.622,0,0,1,.611-.7c.359,0,.6.277.6.707,0,1.008-.006,2.015.01,3.023a.644.644,0,0,0,.168.412c.447.474.918.923,1.375,1.386a.614.614,0,0,1,.066.923.555.555,0,0,1-.4.175A.754.754,0,0,1,19556.941,5058.787Z",
    transform: "translate(-19549.002 -5049.999)",
    fill: "#2d335d",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.f8b4e6402b30f0a0d5c8407f78c06c75.svg";
export { ForwardRef as ReactComponent };